import request from '@/utils/request'

// 创建订单
export function createTaskOrder(data) {
  return request({
    url: '/store/taskOrder/create',
    method: 'post',
    data
  })
}

export function support(data) {
  return request({
    url: '/store/taskOrder/support',
    method: 'post',
    data
  })
}

// 分页查询订单列表
export function getTaskOrderPage(params) {
  return request({
    url: '/store/taskOrder/page',
    method: 'get',
    params
  })
}

// 获取当前期数信息（期号、倒计时、结束时间）
export function getCurrPeriod() {
  return request({
    url: '/store/taskOrder/currPeriod',
    method: 'get'
  })
}